import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Autocomplete,
  InputAdornment,
  Avatar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import { get_root_value } from "src/utils/domUtils";
import { useState } from "react";
import { s3baseUrl } from "src/config/config";
import AddWorkoutCalender from "../AddWorkoutCalender";
import AddWorkoutCalenderModel from "./AddWorkoutCalenderModel";
import { AllActiveWorkoutTypeListingApi } from "src/DAL/workoutType/workoutType";
import { useEffect } from "react";
import { WorkoutListingApi } from "src/DAL/workout/workout";
import CustomConfirmation from "src/components/ModalPopover/Confirmation";
import { useSnackbar } from "notistack";
import moment from "moment";
import { add_program_workout_api } from "src/DAL/programmeWorkout/programmeWorkout";
import { convertToTitleCase } from "src/utils/convertHtml";
import { handleScrollCalled } from "src/utils/constant";
import { Visibility } from "@mui/icons-material";
import WorkoutDetail from "./WorkoutDetail";
import ScheduleWorkouts from "../ScheduleWorkouts";
import CustomPopoverNew from "src/components/CustomPopoverNew";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "10%",
    marginBottom: "10%",
  },
}));
export default function AddWorkoutPopup({
  open,
  setOpen,
  date,
  programme,
  reloadList,
  day,
  setEditWorkputData,
  setEvents,
  events,
}) {
  const [selectedOption, setSelectedOption] = useState("existing");
  const [selectedPracticeTypeOption, setSelectedPracticeTypeOption] =
    useState("workout");
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [multipleType, setMultipleType] = useState([]);
  const [workouts, setWorkouts] = useState([]);
  const [dialogWidth, setDialogWidth] = useState("sm");
  const [workoutType, setWorkoutType] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalChangeExe, setModalChangeExe] = useState(false);
  const [questionsToSend, setQuestionsToSend] = useState([]);
  const [editShow, setEditShow] = useState([]);
  const [inputs, setInputs] = React.useState({
    title: "",
    workout: null,
    difficulty_levels: [],
    target_day: "regular",
    library_type: "workout-type",
    questions: [],
    meals: [],
    workout_note: "",
    type: "",
    comment: "",
  });
  const [newWorkout, setNewWorkout] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [openselectedDetails, setOpenselectedDetails] = useState(false);
  const [isPastedWorkouts, setIsPastedWorkouts] = useState(false);
  const [selectedDay, setSelectedDay] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);

  const handleIconClick = (workout) => {
    setSelectedDetail(workout);
    setOpenselectedDetails(true);
  };

  const [serchText, setSerchText] = useState("");
  const [deleteDoc, setDeleteDoc] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [workoutAsTem, setWorkoutAsTem] = useState();
  const [openCloseDialog, setOpenCloseDialog] = useState(false);
  const childRef = React.useRef();

  const programType = React.useMemo(
    () => programme?._id?.program_type || programme?.program_type,
    [programme],
  );

  const difficultyLevel = React.useMemo(
    () => programme?._id?.difficulty_level || programme?.difficulty_level,
    [programme],
  );

  const handleParentButtonClick = () => {
    childRef.current.childButtonClick();
  };

  const handleParentSaveAsTemplateButtonClick = () => {
    childRef.current.childButtonClick2();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeType = (event) => {
    const {
      target: { value },
    } = event;
    setMultipleType(typeof value === "string" ? value.split(",") : value);
  };

  const handleSaveExistingWorkout = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (programType == "video" && multipleType.length <= 0) {
      enqueueSnackbar(`Please Select Type`, {
        variant: "error",
      });
      setIsLoading(false);

      return;
    }

    if (!inputs.workout) {
      enqueueSnackbar(
        `please select ${convertToTitleCase(selectedPracticeTypeOption)}`,
        { variant: "error" },
      );
      setIsLoading(false);

      return;
    }

    const exerciseId = inputs?.workout?.exercises?.map((item) => {
      let dataToSend = { ...item };
      dataToSend.exercise_info = item.exercise_info;

      return dataToSend;
    });

    const programId = programme?._id?._id || programme?._id;

    const formDataObject = {
      title: inputs.title,
      workout_type: "",
      description: inputs?.workout?.description,
      library_type:
        selectedPracticeTypeOption === "workbook" ? inputs?.library_type : "",
      questions: inputs?.questions || [],
      status: true,
      exercises: exerciseId,
      program_id: programId,
      workout_day: day ? day : 1,
      workout_date: moment(date).format("YYYY-MM-DD"),
      difficulty_levels: inputs.difficulty_levels,
      workout_note: inputs.workout_note,
      practice_type:
        programType == "video"
          ? "video"
          : selectedPracticeTypeOption
          ? selectedPracticeTypeOption
          : "workout",
      video_url: inputs?.workout?.video_url,
      video_thumbnail: inputs?.workout?.video_thumbnail,
    };

    const updatedDays = selectedDay.includes(formDataObject.workout_day)
      ? selectedDay
      : [...selectedDay, formDataObject.workout_day];

    const updatedDates = selectedDate.includes(formDataObject.workout_date)
      ? selectedDate
      : [...selectedDate, formDataObject.workout_date];

    const formData = new FormData();

    formData.append("title", formDataObject.title);
    formData.append("workout_type", formDataObject.workout_type);
    formData.append("description", formDataObject.description);
    formData.append("status", formDataObject.status);
    formData.append(
      "difficulty_levels",
      JSON.stringify(formDataObject.difficulty_levels),
    );
    formData.append("program_id", formDataObject.program_id);
    formData.append("practice_type", formDataObject.practice_type);
    formData.append("comment", inputs?.comment);
    formData.append("exercises", JSON.stringify(formDataObject.exercises));
    formData.append("workout_days", JSON.stringify(updatedDays));
    formData.append("workout_dates", JSON.stringify(updatedDates));
    formData.append("questions", JSON.stringify(formDataObject?.questions));
    formData.append("library_type", formDataObject?.library_type);
    formData.append("workout_note", inputs.workout_note);
    formData.append(
      "video_url",
      formDataObject.video_url ? formDataObject.video_url : "",
    );

    if (formDataObject.video_thumbnail) {
      formData.append(
        "duplicate_image_path",
        JSON.stringify(formDataObject.video_thumbnail),
      );
    }

    if (selectedPracticeTypeOption == "food") {
      formData.append("target_day", inputs.target_day || "regular");
      formData.append("meals", JSON.stringify(inputs.meals || []));
    }

    if (programType == "video") {
      formData.append("video_only_type", JSON.stringify(multipleType));
    }

    const result = await add_program_workout_api(formData);
    if (result.code === 200) {
      setSelectedDate([]);
      setSelectedDay([]);
      setEditWorkputData(result?.workout);
      const workout = result?.workout;

      reloadList();
      setIsLoading(false);

      if (programme?.program_length_type != "limited")
        handleScrollCalled(workout?._id);

      setMultipleType([]);
      setOpen(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleContinue = () => {
    if (programType == "video" && multipleType.length <= 0) {
      enqueueSnackbar(`Please Select Type`, {
        variant: "error",
      });
      setIsLoading(false);
      return;
    }
    if (
      difficultyLevel &&
      inputs.difficulty_levels.length === 0 &&
      selectedOption !== "existing"
    ) {
      enqueueSnackbar(`Please Select Levels`, {
        variant: "error",
      });
      setIsLoading(false);
      return;
    }
    setNewWorkout(true);
  };

  const handleAgreeDelete = (value) => {
    setOpenCloseDialog(true);
  };

  const handleDelete = async () => {
    handleClose();
    setOpenCloseDialog(false);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleOptionPracticeTypChange = (event) => {
    const value = event.target.value;
    setSelectedPracticeTypeOption(value);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    const value = event.target.value;
    setSerchText(value);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const getWorkoutTypes = async () => {
    const result = await AllActiveWorkoutTypeListingApi(
      workoutAsTem?.practice_type
        ? workoutAsTem?.practice_type
        : selectedPracticeTypeOption,
    );
    if (result.code === 200) {
      setWorkoutType(result?.workout_types);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const getExerciseList = async () => {
    let workout_type =
      selectedPracticeTypeOption === "food" ? inputs?.type || "" : "";

    // Use programType from top level scope
    let postData = {
      workout_type: workout_type,
      status: "active",
      practice_type:
        programType == "video" ? "video" : selectedPracticeTypeOption,
    };

    let result = await WorkoutListingApi(0, 100, serchText, postData);
    if (result.code == 200) {
      setInputs((values) => ({
        ...values,
        workout: "",
        title: "",
      }));

      setWorkouts(result?.workouts);
    }
  };

  useEffect(() => {
    if (inputs.workout && inputs.workout?.difficulty_levels) {
      setInputs((values) => ({
        ...values,
        difficulty_levels: inputs.workout?.difficulty_levels,
      }));
    }
  }, [inputs.workout]);

  useEffect(() => {
    getExerciseList();
  }, [serchText, selectedPracticeTypeOption, inputs.type]);

  useEffect(() => {
    if (modalOpen || selectedPracticeTypeOption == "food") {
      getWorkoutTypes();
    }
  }, [modalOpen, selectedPracticeTypeOption]);

  useEffect(() => {
    if (workoutAsTem) setModalOpen(true);
  }, [workoutAsTem]);

  useEffect(() => {
    if (newWorkout) {
      setDialogWidth("lg");
    }
    setModalChangeExe(false);
  }, [newWorkout]);

  useEffect(() => {
    if (open) {
      setDialogWidth("sm");
      setNewWorkout(false);
      setWorkoutAsTem("");
      setModalChangeExe(false);
      setSelectedOption("existing");
      setInputs((values) => ({
        ...values,
        workout: "",
        title: "",
        difficulty_levels: [],
      }));

      setSelectedPracticeTypeOption(
        programType == "video" ? "video" : "workout",
      );
    }
  }, [open, programme]);

  return (
    <div>
      {modalOpen && (
        <AddWorkoutCalenderModel
          onOpen={modalOpen}
          setOnOpen={setModalOpen}
          workoutTypes={workoutType}
          workoutAsTem={workoutAsTem}
        />
      )}
      {openCloseDialog && (
        <CustomConfirmation
          openDelete={openCloseDialog}
          setOpenDelete={setOpenCloseDialog}
          title={"Are you sure you want to Close ?"}
          handleAgree={handleDelete}
        />
      )}
      <Dialog
        disableEnforceFocus={true}
        open={open}
        fullScreen={dialogWidth == "lg" ? true : false}
        fullWidth
        maxWidth={dialogWidth}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="show-dialog-on-full"
      >
        {!newWorkout ? (
          <div
            className={`text-end mt-1 d-flex justify-content-between align-items-center`}
          >
            <DialogTitle
              sx={{
                paddingY: 0,
                color: get_root_value("--portal-theme-primary"),
              }}
            >
              Choose an Option
            </DialogTitle>

            <IconButton
              className="back-screen-button me-1 "
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
        ) : (
          <div className={`text-end mt-1 me-1  `}>
            {modalChangeExe ? (
              <IconButton
                className="back-screen-button"
                onClick={handleAgreeDelete}
              >
                <CloseIcon />
              </IconButton>
            ) : (
              <IconButton
                className="back-screen-button me-1 "
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            )}
          </div>
        )}

        <>
          {!newWorkout ? (
            isLoading ? (
              <CircularProgress className={classes.loading} color="primary" />
            ) : (
              <DialogContent
                sx={{
                  // paddingY: 0,
                  maxHeight: "60vh", // Set a maximum height for the scrollable area
                  overflowY: "auto", // Enable vertical scrolling when content overflows
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ opacity: 0.8, fontSize: 12, mb: 2 }}
                >
                  If you add the workout, it will be added to the calendars of{" "}
                  {programme?.members} users
                </Typography>
                {programType == "video" ? (
                  <FormControl
                    component="fieldset"
                    required
                    fullWidth
                    sx={{ mb: 2 }}
                  >
                    <InputLabel id="select-label">Select Type</InputLabel>
                    <Select
                      labelId="select-label"
                      id="select"
                      multiple
                      // required
                      value={multipleType}
                      onChange={handleChangeType}
                      label="Select Type"
                    >
                      <MenuItem value="workout">Workout</MenuItem>
                      <MenuItem value="food">Meal</MenuItem>
                      <MenuItem value="mindset">Mindset</MenuItem>
                      <MenuItem value="comment">Comment</MenuItem>
                    </Select>
                  </FormControl>
                ) : (
                  <FormControl component="fieldset" fullWidth sx={{ mb: 2 }}>
                    <InputLabel id="select-label">Select Type</InputLabel>
                    <Select
                      labelId="select-label"
                      id="select"
                      value={selectedPracticeTypeOption}
                      onChange={handleOptionPracticeTypChange}
                      label="Select Type"
                    >
                      <MenuItem value="workout">Workout</MenuItem>
                      <MenuItem value="food">Meal</MenuItem>
                      <MenuItem value="mindset">Mindset</MenuItem>
                      <MenuItem value="comment">Comment</MenuItem>
                      <MenuItem value="video">Instructional Video</MenuItem>
                      {programme?.is_allow_workbook && (
                        <MenuItem value="workbook">Workbook</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                )}
                <FormControl component="fieldset" fullWidth sx={{ mb: 2 }}>
                  <InputLabel id="select-label">Select Option</InputLabel>
                  <Select
                    labelId="select-label"
                    id="select"
                    value={selectedOption}
                    onChange={handleOptionChange}
                    label="Select Option"
                  >
                    <MenuItem value="existing">
                      Use From {convertToTitleCase(selectedPracticeTypeOption)}{" "}
                      Library
                    </MenuItem>
                    <MenuItem value="new">
                      New {convertToTitleCase(selectedPracticeTypeOption)}
                    </MenuItem>
                  </Select>
                </FormControl>
                {selectedPracticeTypeOption === "workbook" &&
                selectedOption !== "existing" ? (
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel id="demo-simple-select-label">
                      Workbook Type *
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="library_type"
                      value={inputs.library_type}
                      label="Workbook Type *"
                      onChange={handleChange}
                    >
                      <MenuItem value="workout-type">Workout</MenuItem>
                      <MenuItem value="meal-type">Nutrition</MenuItem>
                      <MenuItem value="mindset-type">Mindset</MenuItem>
                    </Select>
                  </FormControl>
                ) : (
                  ""
                )}
                {selectedPracticeTypeOption === "food" &&
                selectedOption === "existing" ? (
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel id="demo-simple-select-label">
                      Diet Type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="type"
                      value={inputs.type}
                      label="Diet Type"
                      onChange={handleChange}
                    >
                      {workoutType.map((item) => {
                        return (
                          <MenuItem value={item._id} key={item._id}>
                            {item.title}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                ) : (
                  ""
                )}
                {difficultyLevel && selectedOption !== "existing" && (
                  <FormControl fullWidth sx={{ mb: 2 }} required>
                    <InputLabel id="demo-simple-select-label">
                      Difficulty Levels
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      multiple
                      name="difficulty_levels"
                      value={inputs.difficulty_levels}
                      label="Difficulty Levels"
                      onChange={handleChange}
                    >
                      <MenuItem value="novice">Novice</MenuItem>
                      <MenuItem value="intermediate">Intermediate</MenuItem>
                      <MenuItem value="advanced">Advanced</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {selectedOption == "existing" && (
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <Autocomplete
                        id="tags-outlined"
                        options={workouts}
                        getOptionLabel={(option) => option.title}
                        renderOption={(props, option) => (
                          <li {...props}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <Avatar
                                src={s3baseUrl + option?.image?.thumbnail_1}
                                alt={option.title}
                                sx={{
                                  width: 30,
                                  height: 30,
                                  marginRight: 1,
                                  borderRadius: "50%",
                                }}
                              />
                              <span style={{ flexGrow: 1 }}>
                                {option.title}
                              </span>
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleIconClick(option);
                                }}
                              >
                                <Visibility
                                  style={{
                                    fill: "var(--portal-theme-primary)",
                                    fontSize: "18px",
                                  }}
                                />
                              </IconButton>
                            </div>
                          </li>
                        )}
                        filterSelectedOptions
                        value={inputs.workout || null}
                        onChange={(event, newValue) => {
                          setInputs((values) => ({
                            ...values,
                            target_day: newValue?.target_day,
                            meals: newValue?.meals,
                            workout: newValue,
                            title: newValue?.title || "",
                            workout_note: newValue?.workout_note || "",
                            library_type: newValue?.library_type || "",
                            questions: newValue?.questions || [],
                            comment: newValue?.comment || "",
                          }));
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={`${convertToTitleCase(
                              selectedPracticeTypeOption,
                            )}`}
                            placeholder={`${convertToTitleCase(
                              selectedPracticeTypeOption,
                            )}`}
                            onChange={handleSearch}
                            InputProps={{
                              ...params.InputProps,
                              style: { paddingLeft: "6px" },
                              startAdornment: (
                                <InputAdornment position="start">
                                  {inputs?.workout?.image?.thumbnail_1 && (
                                    <Avatar
                                      sx={{ borderRadius: "5px" }}
                                      alt="User Image"
                                      src={
                                        s3baseUrl +
                                        inputs?.workout?.image?.thumbnail_1
                                      }
                                    />
                                  )}
                                </InputAdornment>
                              ),
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <TextField
                        id="outlined-basic"
                        label={`${convertToTitleCase(
                          selectedPracticeTypeOption,
                        )} Name`}
                        variant="outlined"
                        fullWidth
                        required
                        name="title"
                        value={inputs.title}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                )}
              </DialogContent>
            )
          ) : (
            <>
              <DialogContent
                sx={{
                  paddingY: 0,
                  height: "80vh",
                  overflowY: "auto",
                }}
              >
                <AddWorkoutCalender
                  ref={childRef}
                  date={date}
                  programme={programme}
                  setOpen={setOpen}
                  setWorkoutAsTem={setWorkoutAsTem}
                  reloadList={reloadList}
                  events={events}
                  setEvents={setEvents}
                  setEditWorkputData={setEditWorkputData}
                  day={day}
                  setIsLoading={setIsLoading}
                  setModalChangeExe={setModalChangeExe}
                  practice_type={selectedPracticeTypeOption}
                  multipleTypes={multipleType}
                  setMultipleType={setMultipleType}
                  inputs={inputs}
                  questionsToSend={questionsToSend}
                  setQuestionsToSend={setQuestionsToSend}
                  editShow={editShow}
                  setEditShow={setEditShow}
                />
              </DialogContent>
            </>
          )}
          {selectedOption == "existing" ? (
            <DialogActions
              sx={{
                justifyContent:
                  dialogWidth === "lg" ? "flex-start" : "flex-end",
                borderTop: "1px solid rgba(0,0,0,0.12)",
                boxShadow: "0px -1px 4px rgba(0,0,0,0.06)",
                position: "sticky",
                bottom: 0,
                backgroundColor: "background.paper",
                zIndex: 10,
              }}
            >
              <Button
                sx={{ textTransform: "inherit" }}
                onClick={() => {
                  setIsPastedWorkouts(true);
                }}
                size="small"
                color="primary"
                variant="contained"
                className="small-contained-dialog-button me-2"
              >
                Schedule Workout
              </Button>
              <Button
                disabled={isLoading}
                sx={{ textTransform: "inherit" }}
                onClick={isLoading ? "" : handleSaveExistingWorkout}
                size="small"
                color="primary"
                variant="contained"
                className="small-contained-dialog-button"
              >
                Save
              </Button>
            </DialogActions>
          ) : !newWorkout ? (
            <DialogActions
              sx={{
                justifyContent:
                  dialogWidth === "lg" ? "flex-start" : "flex-end",
                borderTop: "1px solid rgba(0,0,0,0.12)",
                boxShadow: "0px -1px 4px rgba(0,0,0,0.06)",
                position: "sticky",
                bottom: 0,
                backgroundColor: "background.paper",
                zIndex: 10,
              }}
            >
              <Button
                onClick={() => {
                  handleContinue();
                }}
                sx={{ textTransform: "inherit" }}
                size="small"
                color="primary"
                variant="contained"
                className="small-contained-dialog-button"
              >
                Continue
              </Button>
            </DialogActions>
          ) : (
            <DialogActions
              sx={{
                justifyContent:
                  dialogWidth === "lg" ? "flex-start" : "flex-end",
                borderTop: "1px solid rgba(0,0,0,0.12)",
                boxShadow: "0px -1px 4px rgba(0,0,0,0.06)",
                position: "sticky",
                bottom: 0,
                backgroundColor: "background.paper",
                zIndex: 10,
              }}
            >
              {selectedPracticeTypeOption !== "workbook" ||
              questionsToSend.length > 0 ? (
                <>
                  <Button
                    disabled={isLoading}
                    onClick={isLoading ? "" : handleParentButtonClick}
                    sx={{ textTransform: "inherit" }}
                    size="small"
                    color="primary"
                    variant="contained"
                    className="small-contained-dialog-button"
                  >
                    Save only
                  </Button>
                  <Button
                    disabled={isLoading}
                    onClick={() => {
                      isLoading ? "" : handleParentSaveAsTemplateButtonClick();
                    }}
                    size="small"
                    color="primary"
                    variant="contained"
                    className="small-contained-dialog-button"
                    sx={{ textTransform: "inherit" }}
                  >
                    Save and save as template
                  </Button>
                </>
              ) : (
                ""
              )}
            </DialogActions>
          )}
        </>
      </Dialog>
      {selectedDetail && (
        <CustomPopoverNew
          isOpenPop={openselectedDetails}
          isClosePop={setOpenselectedDetails}
          title={
            <div className="d-flex align-items-center">
              {selectedDetail?.image?.thumbnail_1 && (
                <img
                  width="50"
                  height="50"
                  style={{ borderRadius: "5px", marginRight: "10px" }}
                  src={s3baseUrl + selectedDetail?.image?.thumbnail_1}
                />
              )}
              <Typography variant="h6">{selectedDetail?.title}</Typography>
            </div>
          }
          componentToPassDown={
            <div className="row px-4 pb-3">
              <WorkoutDetail
                selectedPracticeTypeOption={selectedPracticeTypeOption}
                selectedDetail={selectedDetail}
              />
            </div>
          }
        />
      )}
      <CustomPopoverNew
        isOpenPop={isPastedWorkouts}
        isClosePop={setIsPastedWorkouts}
        title="Schedule Workout"
        componentToPassDown={
          <div className="px-4 pb-3">
            <ScheduleWorkouts
              props={date}
              programme={programme}
              selectedDay={selectedDay}
              setSelectedDay={setSelectedDay}
              setSelectedDate={setSelectedDate}
              selectedDate={selectedDate}
              setIsPastedWorkouts={setIsPastedWorkouts}
            />
          </div>
        }
      />
    </div>
  );
}
